import { StripeCardField } from '@components/stripe/stripe-card-field';
import { InputRadioGroup } from '@goodfynd/forms';
import { FlexView, Text } from '@goodfynd/ui';

import type { ChangePaymentMethodFormProps } from './types';

export const ChangePaymentMethodForm = ({
  control,
  paymentMethods,
  setValue,
  watch,
}: ChangePaymentMethodFormProps) => {
  const paymentMethodId = watch('paymentMethodId');

  const options = [
    ...paymentMethods.map((pm) => ({
      label: pm.display,
      value: pm.id,
    })),
    {
      label: 'Add new card',
      value: 'add-new-card',
    },
  ];

  return (
    <FlexView direction="column" gap={16} width="100%">
      <Text as="body2" color="TextIconSecondary">
        Select a payment method to use as your new default for this
        subscription.
      </Text>
      <InputRadioGroup
        control={control}
        name="paymentMethodId"
        options={options}
      />

      {paymentMethodId === 'add-new-card' && (
        <FlexView direction="column" gap={8} width="100%">
          <Text as="supportingText" color="TextIconSecondary">
            Enter your card details below.
          </Text>
          <StripeCardField
            onComplete={(id) => {
              setValue('stripePaymentMethodId', id, { shouldValidate: true });
            }}
          />
        </FlexView>
      )}
    </FlexView>
  );
};
